import React, {
    FormEvent,
    ReactElement, useState,
} from "react";
import { Form } from "react-bootstrap";
import {
    GetChannelTagsDocument,
    GetConversationSourcesDocument,
    GetSettingsDocument,
    useCreateChannelTagMutation,
} from "../../../__generated__/api";
import Confirm from "../../confirm/Confirm";
import ConversationSources from "../../pickers/conversation-sources/ConversationSources";

export interface DisplayChannelTagProps {
    id?: string;
    isModal?: boolean;
    onSave: (id: string) => void;
    onHide?: () => void;
    className?: string;
}
export default function DisplayChannelTag({
    id, onSave, isModal, onHide, className,
}: DisplayChannelTagProps): ReactElement {
    const [name, setName] = useState<string>();
    const [channelIds, setChannelIds] = useState<string[]>([]);
    const [save] = useCreateChannelTagMutation();

    const onSubmit = (event?: FormEvent) => {
        event?.preventDefault();
        event?.stopPropagation();
        (async () => {
            const created = await save({
                refetchQueries: [
                    { query: GetChannelTagsDocument },
                    { query: GetConversationSourcesDocument },
                    { query: GetSettingsDocument },
                ],
                variables: {
                    channelTag: {
                        channelIds,
                        name,
                    },
                },
            });
            onSave(created.data?.createChannelTag?.name ?? name as string);
        })();
    };

    const form = (
        <div className={className}>
            <h5 className="mb-3 text-light">
                {!id ? "Create" : ""}
                {" "}
                Channel Tag
            </h5>
            <Form.Group className="mb-3">
                <Form.Label className="fw-bolder">Name</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="My Tag"
                    required
                    onChange={evt => setName(evt.target.value)}
                    value={name as string}
                />
                <Form.Text>
                    The name of the channel tag.
                </Form.Text>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label className="fw-bolder">Channels</Form.Label>
                <ConversationSources
                    shouldIncludeTags={false}
                    placeholder="Please pick a channel"
                    isMulti
                    onSelected={ids => setChannelIds(ids)}
                    value={channelIds}
                />
                <Form.Text>
                    Which channels should this tag be applied?
                </Form.Text>
            </Form.Group>

        </div>
    );

    return isModal ? (
        <Confirm
            shouldShow
            confirmText="Create"
            onHide={() => onHide?.()}
            onConfirm={evt => onSubmit(evt)}
        >
            {form}
        </Confirm>
    ) : (
        <form className="flex-grow-1" onSubmit={onSubmit}>
            {form}
        </form>
    );
}
DisplayChannelTag.defaultProps = {
    id: undefined,
    isModal: false,
    onHide: undefined,
    className: undefined,
};
